/**
 * 格式化数字并且返回字符串
 *
 *“ 0≤ 数字 ＜1W ”以下全部显示，如9985 ；
 “ 1W＜数字＜10W ”以上通过显示1位小数并以W作单位，如10900显示为1.1W；
 10W≤ 数字以上通过不再显示小数，如112564显示为12W；
 *
 * @param num
 */
export function formatNum(num) {
    if (num < 10000) {
        return String(num)
    } else if (num < 100000) {
        return String((num / 10000).toFixed(1)).replace('.0', '') + 'W';
    } else {
        return Math.floor((num / 10000)) + 'W';
    }
}